import './App.css';
import {BrowserRouter, Routes,Route} from "react-router-dom";
import WoocommerceDownload from "./pages/WoocommerceDownload";
import MagentoDownload from "./pages/MagentoDownload";
import OpenCartDownload from "./pages/OpenCartDownload";
import ShopifyDocument from "./pages/ShopifyDocument";
import WHMCS from "./pages/WHMCS";
import TermsAndCondtion from "./pages/TermsAndCondtion";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  return (
      <BrowserRouter >
        <Routes>
          <Route path="/plugins/plugin/woocommerce.zip" element={<WoocommerceDownload/>} />
          <Route path="/plugins/plugin/magento2.zip" element={<MagentoDownload/>} />
          <Route path="/plugins/plugin/opencart.zip" element={<OpenCartDownload/>} />
          <Route path="/plugins/plugin/whmcs.zip" element={<WHMCS/>} />
          <Route path="/plugins/plugin/shopify-installation-document.pdf" element={<ShopifyDocument/>} />
            <Route path="/terms_conditions" element={<TermsAndCondtion/>} />
            <Route path="/privacy_policy" element={<PrivacyPolicy/>} />

        </Routes>
      </BrowserRouter>

  );
}

export default App;
